import { api, resolvePagination } from './api';
import { getLastYearDate, getRequestDate } from 'utils/dateUtils';

const nextDay = () => {
    const currentDate = new Date();
    const nextDay = new Date(currentDate);
    nextDay.setDate(currentDate.getDate() + 1);
    return nextDay;
};

/**
 * Get a list of patient data sessions.
 */
export const getRecords = async ({
    patient,
    group,
    plan,
    type,
    pageLimit,
    pageToken,
    qi = getLastYearDate(3),
    df = nextDay()
}) =>
    api.post(
        '/cheart/records',
        {
            type,
            qi: getRequestDate(qi),
            qf: getRequestDate(df),
            patient,
            group,
            plan
        },
        {
            headers: resolvePagination(pageToken, pageLimit)
        }
    );

/**
 * Get a list of patient data sessions.
 */
export const getRecord = async ({ uuid, dtype }) =>
    api.post('/cheart/record/data', {
        uuid,
        dtype
    });

/**
 * Get processed session data blocks (paginated).
 */
export const getProcessedRecord = async ({
    uuid,
    dtype,
    pageLimit,
    pageToken
}) =>
    api.post(
        '/cheart/record/data/processed',
        {
            uuid,
            dtype
        },
        {
            headers: resolvePagination(pageToken, pageLimit)
        }
    );

/**
 * Fetch session data.
 */
export const fetchRecord = async (uuid) =>
    api.post('/cheart/records/fetch', {
        uuid: uuid
    });
